import React from 'react'
import AnamnesisSection from './AnamnesisSection'
import { anamnesisSections, learningInterestCatalog, supportNeedsCatalog } from './anamnesisSchema'

export default function UnifiedAnamnesisForm({ form, setForm, mode = 'full', slots = [], selectedProfessionalName = '' }) {
  const toggleArrayValue = (field, value) => {
    setForm((current) => ({
      ...current,
      [field]: current[field].includes(value) ? current[field].filter((item) => item !== value) : [...current[field], value]
    }))
  }

  const compact = mode === 'compact'

  return (
    <div className="page-stack">
      <section className="surface-card form-section">
        <h2>{compact ? 'Questionário prévio unificado' : 'Questionário de anamnese psicológica'}</h2>
        {selectedProfessionalName ? <p>Profissional selecionado: <strong>{selectedProfessionalName}</strong>.</p> : null}
        <p className="muted">O mesmo formulário apoia atendimento online, agendamento e devolutiva do professor/tutor.</p>
        <div className="grid cols-3">
          <input className="input" placeholder="Nome da criança" value={form.studentName} onChange={(e) => setForm({ ...form, studentName: e.target.value })} />
          <input className="input" placeholder="Idade" value={form.age || ''} onChange={(e) => setForm({ ...form, age: e.target.value })} />
          <input className="input" placeholder="Ano/Série" value={form.schoolYear || ''} onChange={(e) => setForm({ ...form, schoolYear: e.target.value })} />
          {!compact ? <input className="input" type="date" value={form.appointmentDate || ''} onChange={(e) => setForm({ ...form, appointmentDate: e.target.value })} required /> : null}
          {!compact ? (
            <select className="input" value={String(form.appointmentTime || '10:00:00').slice(0, 5)} onChange={(e) => setForm({ ...form, appointmentTime: `${e.target.value}:00` })}>
              {(slots.length ? slots : ['10:00']).map((slot) => <option key={slot} value={slot}>{slot}</option>)}
            </select>
          ) : null}
          <input className="input" placeholder={compact ? 'Observações iniciais para o atendimento' : 'Observações iniciais'} value={form.notes || ''} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
        </div>
      </section>

      <section className="surface-card form-section">
        <h3>Perfil e necessidades</h3>
        <div className="button-wrap">
          {supportNeedsCatalog.map((item) => (
            <button type="button" key={item} onClick={() => toggleArrayValue('supportNeeds', item)} className={`chip ${form.supportNeeds.includes(item) ? 'chip-active' : ''}`}>{item}</button>
          ))}
        </div>
        <div className="button-wrap">
          {learningInterestCatalog.map((item) => (
            <button type="button" key={item} onClick={() => toggleArrayValue('interests', item)} className={`chip chip-success ${form.interests.includes(item) ? 'chip-active-green' : ''}`}>{item}</button>
          ))}
        </div>
        <div className="grid cols-2">
          <textarea className="input textarea" placeholder="Principais queixas atuais" value={form.currentComplaints || ''} onChange={(e) => setForm({ ...form, currentComplaints: e.target.value })} />
          <textarea className="input textarea" placeholder="Motivo da consulta" value={form.reasonForConsultation || ''} onChange={(e) => setForm({ ...form, reasonForConsultation: e.target.value })} />
          <textarea className="input textarea" placeholder="Desafios matemáticos" value={Array.isArray(form.mathChallenges) ? form.mathChallenges.join(', ') : (form.mathChallenges || '')} onChange={(e) => setForm({ ...form, mathChallenges: e.target.value.split(',').map((item) => item.trim()).filter(Boolean) })} />
          <textarea className="input textarea" placeholder="Hipóteses diagnósticas / observações clínicas" value={Array.isArray(form.diagnosisNotes) ? form.diagnosisNotes.join(', ') : (form.diagnosisNotes || '')} onChange={(e) => setForm({ ...form, diagnosisNotes: e.target.value.split(',').map((item) => item.trim()).filter(Boolean) })} />
        </div>
      </section>

      {(compact ? anamnesisSections.slice(1) : anamnesisSections).map((section) => (
        <AnamnesisSection key={section.title} title={section.title} fields={section.fields} form={form} setForm={setForm} />
      ))}
    </div>
  )
}
